{
  "success": true,
  "errorMessage": "",
  "numadults": 2,
  "numchildren": 2,
  "quoteno": 2320428034,
  "schemes": [
    {
      "name": "Worldwide Excluding USA & Canada",
      "price": 345,
      "schemecode": "5002",
      "productcode": "0180",
      "deductible": 0,
      "excessCovers": [
        {
          "code": "8001",
          "name": "*Travel Excess (USD)",
          "premium": "50",
          "help": null,
          "wordings": null,
          "benefits": null
        },
        {
          "code": "8006",
          "name": "*Travel Covid Excess (USD)",
          "premium": "100",
          "help": null,
          "wordings": null,
          "benefits": null
        }
      ],
      "discount": 100,
      "discounts": [
        {
          "name": "Online purchase discount",
          "premium": 38
        }
      ],
      "included": [
        {
          "id": "08016",
          "name": "Travel Insurance Cover",
          "description": "Covers basic medical expenses, including inpatient treatment, repatriation, and medecine consulting service.",
          "value": 345,
          "benefits": []
        },
        {
          "id": "08054",
          "name": "Covid-19 Cover",
          "description": "Covers medical, hospitalization, quarantine and trip cancelation fees in case of a COVID-19 infection.",
          "value": 0,
          "benefits": []
        },
        {
          "id": "08052",
          "name": "Emergency Medical Cover",
          "description": "Covers medical expenses you have to pay in case of medical emergencies.",
          "value": 0,
          "benefits": [
            {
              "id": "8002",
              "name": "Medical Expenses",
              "description": "Coverage of inpatient treatment, cremation, repatriation costs, emergency call center assistance and medical consulting services.",
              "price": "1,000,000"
            },
            {
              "id": "8003",
              "name": "Worldwide Medical Emergency Assistance",
              "description": "24h medical assistance services in the event of suffering a medical emergency during your trip.",
              "price": "Yes"
            }
          ]
        },
        {
          "id": "08053",
          "name": "Travel Inconvenience Cover",
          "description": "Covers unexpected expenses related to flight cancellation or delay, and loss of baggage and passport.",
          "value": 0,
          "benefits": [
            {
              "id": "8000",
              "name": "Curtailment",
              "description": "Coverage of losing advance / deposits due to unavoidable curtailment of your trip.",
              "price": "5,000"
            },
            {
              "id": "8001",
              "name": "Travel Excess (USD)",
              "description": "",
              "price": "1,000"
            },
            {
              "id": "8004",
              "name": "Travel Baggage ",
              "description": "Compensation for lost or damaged luggage and belongings during the operative time of coverage.",
              "price": "5,000"
            },
            {
              "id": "8005",
              "name": "Loss of Passport",
              "description": "Coverage of additional charges for getting a replacement travel document if your passport is lost.",
              "price": "500"
            },
            {
              "id": "8006",
              "name": "Overseas Legal Expenses ",
              "description": "Coverage of legal costs to pursue a civil action for compensation if a third party causes bodily injuries, illness or death.",
              "price": "25,000"
            },
            {
              "id": "8007",
              "name": "Travel Accidents",
              "description": "Coverage of injuries, disability, loss of organs and death resulted from an accident.",
              "price": "50,000"
            },
            {
              "id": "8008",
              "name": "Personal Liability insurance for Travel ",
              "description": "Covers your legal costs & expenses resulting from third party death or bodily injury or third party property damage.",
              "price": "1,000,000"
            },
            {
              "id": "8010",
              "name": "Hijack",
              "description": "Covers an amount of USD 250 per day up to the limit of USD 1500, in the event of hijacking the transport on which the insured person is travelling.",
              "price": "1,500"
            },
            {
              "id": "8011",
              "name": "Sport Equipment",
              "description": "Covers accompanied sport equipment of the insured when travelling.",
              "price": "1,000"
            }
          ]
        }
      ],
      "ids": [
        {
          "id": "08050",
          "name": "Winter Sports Cover",
          "description": "Covers expenses arising from accidents that can occur while skiing on a piste.",
          "value": 180,
          "benefits": []
        },
        {
          "id": "08051",
          "name": "Terrorism Extension",
          "description": "Covers expenses arising from accidents that might happen due to terrorism acts.",
          "value": 180,
          "benefits": []
        }
      ],
      "addons": [
        {
          "id": "08016",
          "name": "Travel Insurance Cover",
          "description": "Covers basic medical expenses, including inpatient treatment, repatriation, and medecine consulting service.",
          "checked": true
        },
        {
          "id": "08051",
          "name": "Terrorism Extension",
          "description": "Covers expenses arising from accidents that might happen due to terrorism acts.",
          "checked": false
        },
        {
          "id": "08052",
          "name": "Emergency Medical Cover",
          "description": "Covers medical expenses you have to pay in case of medical emergencies.",
          "checked": true
        },
        {
          "id": "08054",
          "name": "Covid-19 Cover",
          "description": "Covers medical, hospitalization, quarantine and trip cancelation fees in case of a COVID-19 infection.",
          "checked": true
        },
        {
          "id": "08053",
          "name": "Travel Inconvenience Cover",
          "description": "Covers unexpected expenses related to flight cancellation or delay, and loss of baggage and passport.",
          "checked": true
        }
      ]
    },
    {
      "name": "Worldwide",
      "price": 504,
      "schemecode": "5003",
      "productcode": "0180",
      "deductible": 0,
      "excessCovers": [
        {
          "code": "8001",
          "name": "*Travel Excess (USD)",
          "premium": "50",
          "help": null,
          "wordings": null,
          "benefits": null
        },
        {
          "code": "8006",
          "name": "*Travel Covid Excess (USD)",
          "premium": "100",
          "help": null,
          "wordings": null,
          "benefits": null
        }
      ],
      "discount": 0,
      "discounts": [],
      "included": [
        {
          "id": "08016",
          "name": "Travel Insurance Cover",
          "description": "Covers basic medical expenses, including inpatient treatment, repatriation, and medecine consulting service.",
          "value": 504,
          "benefits": []
        },
        {
          "id": "08054",
          "name": "Covid-19 Cover",
          "description": "Covers medical, hospitalization, quarantine and trip cancelation fees in case of a COVID-19 infection.",
          "value": 0,
          "benefits": []
        },
        {
          "id": "08052",
          "name": "Emergency Medical Cover",
          "description": "Covers medical expenses you have to pay in case of medical emergencies.",
          "value": 0,
          "benefits": [
            {
              "id": "8002",
              "name": "Medical Expenses",
              "description": "Coverage of inpatient treatment, cremation, repatriation costs, emergency call center assistance and medical consulting services.",
              "price": "1,000,000"
            },
            {
              "id": "8003",
              "name": "Worldwide Medical Emergency Assistance",
              "description": "24h medical assistance services in the event of suffering a medical emergency during your trip.",
              "price": "Yes"
            }
          ]
        },
        {
          "id": "08053",
          "name": "Travel Inconvenience Cover",
          "description": "Covers unexpected expenses related to flight cancellation or delay, and loss of baggage and passport.",
          "value": 0,
          "benefits": [
            {
              "id": "8000",
              "name": "Curtailment",
              "description": "Coverage of losing advance / deposits due to unavoidable curtailment of your trip.",
              "price": "5,000"
            },
            {
              "id": "8001",
              "name": "Travel Excess (USD)",
              "description": "",
              "price": "1,000"
            },
            {
              "id": "8004",
              "name": "Travel Baggage ",
              "description": "Compensation for lost or damaged luggage and belongings during the operative time of coverage.",
              "price": "5,000"
            },
            {
              "id": "8005",
              "name": "Loss of Passport",
              "description": "Coverage of additional charges for getting a replacement travel document if your passport is lost.",
              "price": "500"
            },
            {
              "id": "8006",
              "name": "Overseas Legal Expenses ",
              "description": "Coverage of legal costs to pursue a civil action for compensation if a third party causes bodily injuries, illness or death.",
              "price": "25,000"
            },
            {
              "id": "8007",
              "name": "Travel Accidents",
              "description": "Coverage of injuries, disability, loss of organs and death resulted from an accident.",
              "price": "50,000"
            },
            {
              "id": "8008",
              "name": "Personal Liability insurance for Travel ",
              "description": "Covers your legal costs & expenses resulting from third party death or bodily injury or third party property damage.",
              "price": "1,000,000"
            },
            {
              "id": "8010",
              "name": "Hijack",
              "description": "Covers an amount of USD 250 per day up to the limit of USD 1500, in the event of hijacking the transport on which the insured person is travelling.",
              "price": "1,500"
            },
            {
              "id": "8011",
              "name": "Sport Equipment",
              "description": "Covers accompanied sport equipment of the insured when travelling.",
              "price": "1,000"
            }
          ]
        }
      ],
      "ids": [
        {
          "id": "08050",
          "name": "Winter Sports Cover",
          "description": "Covers expenses arising from accidents that can occur while skiing on a piste.",
          "value": 180,
          "benefits": []
        },
        {
          "id": "08051",
          "name": "Terrorism Extension",
          "description": "Covers expenses arising from accidents that might happen due to terrorism acts.",
          "value": 180,
          "benefits": []
        }
      ],
      "addons": [
        {
          "id": "08016",
          "name": "Travel Insurance Cover",
          "description": "Covers basic medical expenses, including inpatient treatment, repatriation, and medecine consulting service.",
          "checked": true
        },
        {
          "id": "08051",
          "name": "Terrorism Extension",
          "description": "Covers expenses arising from accidents that might happen due to terrorism acts.",
          "checked": false
        },
        {
          "id": "08052",
          "name": "Emergency Medical Cover",
          "description": "Covers medical expenses you have to pay in case of medical emergencies.",
          "checked": true
        },
        {
          "id": "08054",
          "name": "Covid-19 Cover",
          "description": "Covers medical, hospitalization, quarantine and trip cancelation fees in case of a COVID-19 infection.",
          "checked": true
        },
        {
          "id": "08053",
          "name": "Travel Inconvenience Cover",
          "description": "Covers unexpected expenses related to flight cancellation or delay, and loss of baggage and passport.",
          "checked": true
        }
      ]
    },
    {
      "name": "Fly Europe",
      "price": 210,
      "schemecode": "5004",
      "productcode": "0180",
      "deductible": 0,
      "excessCovers": [
        {
          "code": "8001",
          "name": "*Travel Excess (USD)",
          "premium": "50",
          "help": null,
          "wordings": null,
          "benefits": null
        }
      ],
      "discount": 0,
      "discounts": [],
      "included": [
        {
          "id": "08016",
          "name": "Travel Insurance Cover",
          "description": "Covers basic medical expenses, including inpatient treatment, repatriation, and medecine consulting service.",
          "value": 210,
          "benefits": []
        },
        {
          "id": "08051",
          "name": "Terrorism Extension",
          "description": "Covers expenses arising from accidents that might happen due to terrorism acts.",
          "value": 0,
          "benefits": []
        },
        {
          "id": "08052",
          "name": "Emergency Medical Cover",
          "description": "Covers medical expenses you have to pay in case of medical emergencies.",
          "value": 0,
          "benefits": [
            {
              "id": "8002",
              "name": "Medical Expenses",
              "description": "Coverage of inpatient treatment, cremation, repatriation costs, emergency call center assistance and medical consulting services.",
              "price": "50,000"
            },
            {
              "id": "8003",
              "name": "Worldwide Medical Emergency Assistance",
              "description": "24h medical assistance services in the event of suffering a medical emergency during your trip.",
              "price": "Yes"
            }
          ]
        }
      ],
      "ids": [],
      "addons": [
        {
          "id": "08016",
          "name": "Travel Insurance Cover",
          "description": "Covers basic medical expenses, including inpatient treatment, repatriation, and medecine consulting service.",
          "checked": true
        },
        {
          "id": "08051",
          "name": "Terrorism Extension",
          "description": "Covers expenses arising from accidents that might happen due to terrorism acts.",
          "checked": true
        },
        {
          "id": "08052",
          "name": "Emergency Medical Cover",
          "description": "Covers medical expenses you have to pay in case of medical emergencies.",
          "checked": true
        },
        {
          "id": "08054",
          "name": "Covid-19 Cover",
          "description": "Covers medical, hospitalization, quarantine and trip cancelation fees in case of a COVID-19 infection.",
          "checked": false
        },
        {
          "id": "08053",
          "name": "Travel Inconvenience Cover",
          "description": "Covers unexpected expenses related to flight cancellation or delay, and loss of baggage and passport.",
          "checked": false
        }
      ]
    }
  ],
  "addons": [
    {
      "id": "08016",
      "name": "Travel Insurance Cover",
      "description": "Covers basic medical expenses, including inpatient treatment, repatriation, and medecine consulting service."
    },
    {
      "id": "08051",
      "name": "Terrorism Extension",
      "description": "Covers expenses arising from accidents that might happen due to terrorism acts."
    },
    {
      "id": "08052",
      "name": "Emergency Medical Cover",
      "description": "Covers medical expenses you have to pay in case of medical emergencies."
    },
    {
      "id": "08054",
      "name": "Covid-19 Cover",
      "description": "Covers medical, hospitalization, quarantine and trip cancelation fees in case of a COVID-19 infection."
    },
    {
      "id": "08053",
      "name": "Travel Inconvenience Cover",
      "description": "Covers unexpected expenses related to flight cancellation or delay, and loss of baggage and passport."
    }
  ]
}
